import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';

/**
 * fof/byobu's /private (routeName 'byobuPrivate') is core's IndexPage over
 * the same app.discussions list as the homepage, with the same search
 * params: only its requestParams() extend adds the private filter, from the
 * current route. So back on the homepage core's refreshParams() sees nothing
 * changed and keeps the private list - unless coming straight from /private
 * (IndexPage to IndexPage always clears it). /private, then a discussion,
 * then "Accueil" showed the private discussions.
 *
 * Reloads it on any other discussion list (homepage, a tag) then - unless
 * core already does (different params, a tag's). byobu handles the other
 * way round itself (PrivateDiscussionsPage.js, a clear() on /private).
 */
let listIsPrivate = false;
export default function refreshListAfterPrivateDiscussions() {
  extend(IndexPage.prototype, 'oninit', function () {
    const isPrivate = app.current.get('routeName') === 'byobuPrivate';
    if (listIsPrivate && !isPrivate && !app.discussions.isInitialLoading()) {
      app.discussions.refresh();
    }
    listIsPrivate = isPrivate;
  });
}